import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

type CreateTlcSquadProps = {
  tlcId?: string;
  teamLeadPodTypeId?: string;
  createDiscourseCommunityChannel?: boolean;
  communityChannelName?: string;
};

export const useCreateTlcSquad = () => {
  return useMutation(
    [`useCreateTlcSquad`],
    ({
      tlcId,
      teamLeadPodTypeId,
      createDiscourseCommunityChannel,
      communityChannelName,
    }: CreateTlcSquadProps) =>
      apiFetch(null, `internal/expert-management/squads/tlc/create`, {
        method: 'POST',
        body: {
          tlcId,
          teamLeadPodTypeId,
          createDiscourseCommunityChannel,
          communityChannelName,
        },
      }),
  );
};
